import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyDDbfg5QC522mr3wIKX8pkt6_d5alZx3xc",
  authDomain: "minor-project-icb.firebaseapp.com",
  databaseURL: "https://minor-project-icb-default-rtdb.firebaseio.com",
  projectId: "minor-project-icb",
  storageBucket: "minor-project-icb.appspot.com",
  messagingSenderId: "1019358154980",
  appId: "1:1019358154980:web:5d8d7d5f671db39292dcf1"
};


export const app = initializeApp(firebaseConfig);